import { h, m2, euros, num, textoAgua } from '../dom';
import type { CandidatoCompleto } from '../../db/consultas';
import { urlFotoFachada } from '../../catastro/ovc';
import { nombreUso, nombreEstado } from '../../catastro/gml';

/** Filas del comparador: cada una sabe extraer su valor de un candidato. */
export interface FilaComparador {
  nombre: string;
  valor: (c: CandidatoCompleto) => string;
}

export const FILAS_COMPARADOR: FilaComparador[] = [
  { nombre: 'Etiqueta', valor: (c) => c.etiqueta ?? '—' },
  { nombre: 'Referencia', valor: (c) => c.rc },
  { nombre: 'Dirección', valor: (c) => c.inmuebles[0]?.direccion ?? '—' },
  { nombre: 'Parcela', valor: (c) => m2(c.parcela?.areaM2) },
  { nombre: 'Agua más cercana (IGN)', valor: (c) => textoAgua(c.parcela?.distAguaM, c.parcela?.aguaNombre) },
  { nombre: 'Construida', valor: (c) => m2(c.edificio?.supConstruidaM2) },
  { nombre: 'Huella', valor: (c) => m2(c.edificio?.huellaM2) },
  { nombre: 'Plantas', valor: (c) => num(c.edificio?.plantas) },
  { nombre: 'Año', valor: (c) => num(c.edificio?.anio) },
  { nombre: 'Uso', valor: (c) => nombreUso(c.edificio?.uso ?? null) },
  { nombre: 'Estado', valor: (c) => nombreEstado(c.edificio?.estado ?? null) },
  { nombre: 'Viviendas', valor: (c) => num(c.edificio?.viviendas) },
  { nombre: 'Inmuebles consultados', valor: (c) => (c.inmuebles.length ? String(c.inmuebles.length) : '—') },
  { nombre: 'Alero / cumbrera (LiDAR)', valor: (c) => (c.edificio?.aleroM != null ? `${num(c.edificio.aleroM, 1)} / ${num(c.edificio.cumbreraM, 1)} m` : '—') },
  { nombre: 'Precio', valor: (c) => euros(c.precio) },
  { nombre: '€/m² construido', valor: (c) => (c.precio != null && c.edificio?.supConstruidaM2 ? euros(c.precio / c.edificio.supConstruidaM2) : '—') },
  { nombre: '€/m² de parcela', valor: (c) => (c.precio != null && c.parcela?.areaM2 ? euros(c.precio / c.parcela.areaM2) : '—') },
  { nombre: 'Anuncio', valor: (c) => c.anuncioUrl ?? '—' },
  { nombre: 'Notas', valor: (c) => c.notas ?? '—' },
];

/** Tabla lado a lado de los candidatos, en una ventana. */
export function abrirComparador(candidatos: CandidatoCompleto[], onPdf: () => void, onVer: (rc: string) => void): void {
  const cerrar = () => fondo.remove();
  const tabla = h('table', { class: 'comparador' },
    h('thead', null, h('tr', null, h('th', null, ''), ...candidatos.map((c) =>
      h('th', null, h('button', { class: 'enlace rc', onClick: () => { cerrar(); onVer(c.rc); } }, c.etiqueta ? `${c.etiqueta} · ${c.rc}` : c.rc))))),
    h('tbody', null,
      h('tr', null, h('th', null, 'Fachada'), ...candidatos.map((c) => h('td', null,
        h('img', { class: 'foto-comp', src: urlFotoFachada(c.rc), alt: '', loading: 'lazy', onError: (ev: Event) => { (ev.target as HTMLElement).style.display = 'none'; } })))),
      ...FILAS_COMPARADOR.map((f) => h('tr', null, h('th', null, f.nombre), ...candidatos.map((c) => {
        const v = f.valor(c);
        return h('td', null, f.nombre === 'Anuncio' && v !== '—' ? h('a', { href: v, target: '_blank', rel: 'noopener' }, 'abrir') : v);
      })))));
  const fondo = h('div', { class: 'modal-fondo', onClick: (ev: Event) => { if (ev.target === fondo) cerrar(); } },
    h('div', { class: 'modal ancha' },
      h('div', { class: 'ficha-cabecera' }, h('h2', null, `Comparador (${candidatos.length})`), h('button', { class: 'cerrar', onClick: cerrar }, '×')),
      h('div', { style: 'overflow:auto' }, tabla),
      h('div', { class: 'fila-botones' },
        h('button', { class: 'boton primario', onClick: () => { cerrar(); onPdf(); } }, 'Informe PDF de la comparativa'),
        h('button', { class: 'boton secundario', onClick: cerrar }, 'Cerrar'))));
  document.body.append(fondo);
}
